/** this is how many results should exist before and current index to start fetching more */
export const RESULTS_MORE_BUFFER_SIZE = 2;
